import React, {Component} from 'react'
import Header from 'lib/struct/headers/Header'
import CampaignSettings from './CampaignSettings/CampaignSettings'

import styles from './CampaignTab.less'
import CustomSettings from "./CampaignSettings/CustomSettings";

const {
    'campaign-settings-header': campaignSettingsHeader,
    'campaign-id-span': campaignIdSpan
} = styles

const labels = {
    'DBS': 'Настройки кампании по модели DBS (Delivery by Seller)',
    'FBS': 'Настройки кампании по модели FBS (Fulfillment by Seller)',
    'FBSX': 'Настройки кампании по модели FBS Express (экспресс-доставка заказов курьерами)',
}

class CampaignTab extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        let {settings, statuses, campaign, onCampaignDelete, context, api_url} = this.props
        let tabContent
        let tabHeader

        tabHeader = (
            <div>
                <div className={campaignSettingsHeader} id={'campaign-'+campaign.id}>
                    {(campaign.custom && <CustomSettings onCampaignDelete={onCampaignDelete} campaign={campaign}/>)}
                    <Header>
                        {!campaign.custom ? labels[campaign.type] : "Настройки кампании"}
                        <span className={campaignIdSpan}>Id: {campaign.id}</span>
                    </Header>
                </div>
            </div>
        )

        tabContent =
            <CampaignSettings statuses={statuses} settings={settings} type={campaign.type} context={context} api_url={api_url}
                              campaign={campaign}/>


        return (
            <div key={campaign.type+'-'+campaign.id}>
                {tabHeader}
                {tabContent}
            </div>
        )
    }
}

export default CampaignTab